export default __webpack_public_path__ + "static/media/About_Icon_Male.597163bc.png";